import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const authGiftCardIntegrationContract = c.router(
  {
    getGiftCardRedeemUrl: {
      method: 'GET',
      path: '/gift-card/redeem-url',
      query: z.object({
        prizeOrderProductId: z.string(),
      }),
      responses: {
        200: z.string(),
        404: z.object({
          message: z.string(),
        }),
      },
    },
  },
  {
    pathPrefix: '/auth',
    baseHeaders: z.object({
      'x-access-token': z.string(),
    }),
    commonResponses: {
      401: c.type<{ message: string; statusCode: 401 }>(),
    },
  }
);
